import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../services/api";
import { useAuth } from "./AuthContext";

const CarritoContext = createContext();

export function useCarrito() {
  return useContext(CarritoContext);
}

export function CarritoProvider({ children }) {
  const { user } = useAuth();
  const [carritoCount, setCartCount] = useState({ id_carrito: 0, total_items: 0 });
  const [carrito, setCarrito] = useState(null);
  const [loading, setLoading] = useState(false);

  // Refresca el conteo cuando el usuario está autenticado (no requiere cliente)
  useEffect(() => {
    if (user?.id) {
      fetchCartCount();
    } else {
      setCartCount({ id_carrito: 0, total_items: 0 });
      setCarrito(null);
    }
  }, [user]);

  useEffect(() => {
    if (carritoCount.id_carrito) {
      fetchCarrito();
    } else {
      setCarrito(null);
    }
  }, [carritoCount.id_carrito]);

  const fetchCartCount = async () => {
    if (!user?.id) return;
    setLoading(true);
    const res = await api.carrito.count();
    setCartCount(res.data?.carrito_count || { id_carrito: 0, total_items: 0 });
    setLoading(false);
  };

  const fetchCarrito = async () => {
    if (!carritoCount.id_carrito) {
      setCarrito(null);
      return;
    }
    setLoading(true);
    const response = await api.carrito.get(carritoCount.id_carrito);
    if (response.status === "success") {
      setCarrito(response.data.carrito);
    } else {
      setCarrito(null);
    }
    setLoading(false);
  };

  const refreshCart = async () => {
    await fetchCartCount();
  };

  const addItems = async (producto, cantidad) => {
    if (!user?.id) return;

    const dataParaEnviar = {
      id_producto: producto.id_producto ?? producto.ID,
      cantidad,
      precio: producto.precio_unit ?? producto.Precio ?? producto.precio,
      nombre_producto: producto.producto ?? producto.Producto ?? "",
      codigo_producto: producto.codigo ?? producto.Codigo ?? "",
      id_variante: producto.id_variante ?? null,
      combinacion: producto.combinacion ?? "",
    };

    const response = await api.carrito.addItem(dataParaEnviar);
    if (response.status === "success") {
      await Promise.all([fetchCartCount(), fetchCarrito()]);
      window.dispatchEvent(new Event("cartUpdate"));
    }
    return response;
  };

  const deleteItem = async (id) => {
    const response = await api.carrito.deleteItem(id);
    if (response.status === "success") {
      await Promise.all([fetchCartCount(), fetchCarrito()]);
      window.dispatchEvent(new Event("cartUpdate"));
    }
    return response;
  };

  return (
    <CarritoContext.Provider value={{
      carritoCount,
      carrito,
      loading,
      refreshCart,
      addItems,
      deleteItem,
      setCartCount,
      setCarrito,
    }}>
      {children}
    </CarritoContext.Provider>
  );
}
